import React, {useEffect, useState} from "react";
import passaporteApi from "../../../../../services/passaporteApi";
import Alert from "../../../../../helpers/Alert";
import quantidade from "../../../../../helpers/QuantidadeFormularios";
import processosApi from "../../../../../services/processosApi";
import HeaderForm from "../../../../../components/headerForm";
import Form from "../../../../../components/form/Form";
import Button from "../../../../../components/button/Button";
import Input from "../../../../../components/input/Input";
import { getNumeroPassaporteCliente } from "../../../../../helpers/passaporteCliente";

export interface IPassaporteCa{
    processo?: any;
    setProcesso?: any;
    setTelaNumero?: any;
    telanumero?: any;
    conjujeAnterior?: any;
}

export default function PassaporteCa({processo, setProcesso, setTelaNumero, telanumero, conjujeAnterior}: IPassaporteCa) {
    const [state, setState] = useState({
        id: '',
        processo_id: processo.id,
        numero: processo.cliente?.numero_passaporte || '',
        pais_emissor: '',
        data_emissao: '',
        data_validade: '',
    })
    const [numeroTelaAnterior, setNumeroTelaAnterior] = useState(telanumero-3)
    useEffect(() => {
        let numAnt = 1;

        if (processo.cliente.estado_civil !== 'solteiro'){
            if (conjujeAnterior){
                numAnt = telanumero-1
            }else{
                numAnt = telanumero-2
            }
        }else{
            numAnt = 1;
        }

        setNumeroTelaAnterior(numAnt);
        getDadosPassaporte();

    }, []);
    const getDadosPassaporte = async () => {
        const {data, isError} = await passaporteApi.one(processo.id);
        const numeroCliente = await getNumeroPassaporteCliente(processo);
        if (!isError && Object.values(data.data).length) {
            const loaded = data.data;
            if (!loaded.numero && numeroCliente) loaded.numero = numeroCliente;
            setState(loaded);
        } else if (numeroCliente) {
            setState(prev => ({ ...prev, numero: numeroCliente }));
        }
    }
    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };
    const onSubmit = async () => {
        Alert.await("Salvando dados");
        const {data, isError} = state.id ? await passaporteApi.update(state.id, state) : await passaporteApi.create(state);
        if (isError){
            if (typeof data.data === 'object') {
                Object.keys(data.data.errors).forEach(function(key, index) {
                    Alert.error(data.data.errors[key][0]);
                });
                return;
            }
            return Alert.error(data.data.message? data.data.message : data.data);
        }
        if (!state.id){
            const percent = (telanumero * 100) / quantidade[processo.tipo_visto_id];
            await processosApi.update(processo.id, {percet_conclusao: percent})
            setProcesso({...processo, ['percet_conclusao']: percent})
        }
        Alert.close();
        window.scrollTo(0, 0);
        let numero = telanumero + 1;
        setTelaNumero(numero);
    }
    return(
        <>
            <HeaderForm
                titulo={'Dados do passaporte'}
                numeroPaginalAtual={telanumero}
                numeroTotal={quantidade[processo.tipo_visto_id]}
                percentual={processo.percet_conclusao}
            />
            <Form  onSubmit={() => onSubmit()}>
                <div className={'p-5'}>
                    <div className={'grid md:grid-cols-2 gap-4 mt-5'}>
                        <Input
                            className={'col-span-1'}
                            label={'Número do passaporte válido'}
                            placeholder={'Número do passaporte válido'}
                            large={true}
                            name={'numero'}
                            setValue={e => handleChange(e,'numero')}
                            value={state.numero}
                            required
                        />
                        <Input
                            className={'col-span-1'}
                            label={'País que emitiu o passaporte '}
                            placeholder={'País que emitiu o passaporte'}
                            large={true}
                            name={'pais_emissor'}
                            setValue={e => handleChange(e,'pais_emissor')}
                            value={state.pais_emissor}
                            required
                        />
                    </div>
                    <div className={'grid md:grid-cols-2 gap-4 mt-5'}>
                        <Input
                            className={'col-span-1'}
                            label={'Data de emissão '}
                            placeholder={'Data de emissão'}
                            large={true}
                            type={'date'}
                            name={'data_emissao'}
                            setValue={e => handleChange(e,'data_emissao')}
                            value={state.data_emissao}
                            required
                        />
                        <Input
                            className={'col-span-1'}
                            label={'Valido até '}
                            placeholder={'Valido até'}
                            large={true}
                            type={'date'}
                            name={'data_validade'}
                            setValue={e => handleChange(e,'data_validade')}
                            value={state.data_validade}
                            required
                        />
                    </div>
                </div>
                <div className={'border-2'}></div>
                <div className={'flex justify-between p-5'}>
                    <Button
                        onClick={() => {
                            console.log(numeroTelaAnterior)
                            setTelaNumero(numeroTelaAnterior)
                        }}
                        className={'w-[164px] h-[48px] bg-white text-gray-800 border border-gray-500 font-semibold'}
                    >
                        Voltar
                    </Button>
                    <Button
                        type={'submit'}
                        className={'w-[164px] h-[48px] bg-[#082a60] text-white font-semibold'}
                    >
                        Continuar
                    </Button>
                </div>
            </Form>
        </>
    )
}